export default __webpack_public_path__ + "static/media/skGoel.39a99907.webp";